import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import DataTable from 'components/shared/DataTable';
import { Column } from 'components/shared/DataTable/DataTable';
import Grid from 'components/UI/Grid';
import Loading from 'components/UI/Loading/Loading';
import { Paper } from '@mui/material';
import { FilterMatchMode } from 'primereact/api';
import { DataTableRowClickEvent } from 'primereact/datatable';
// import useInactiveRowClassName from 'hooks/datatable/useInactiveRowClassName';
// import { GrowerSystem } from 'models/grower';
// import { SensorType } from 'models/api/sensor';
import { ApiStaticKey } from 'models/protocol';
// import { Dialog } from 'primereact/dialog';
// import { Button } from 'primereact/button';
// import ReactJson from 'react-json-view';

const StyledGrid = styled(Grid)`
  display: flex;
  flex: unset;
  height: 100%;
  width: 100%;
  align-items: normal;
`;

const DataTableContainer = styled(Paper)`
  overflow: hidden;
  height: 100%;
  background-color: var(--surface-ground);
`;

// const MetaDataDialog = styled(Dialog)`
//   .p-dialog-content {
//     padding: 1.5rem;
//   }
// `;

// const JsonViewContainer = styled.div`
//   .react-json-view {
//     background-color: ${(props) => props.theme.palette.background.paper};
//     padding: 1rem;
//     border-radius: 4px;
//   }
// `;

const ApiKeysTable: FC<{ apiKeys: ApiStaticKey[]; isLoading: boolean }> =
  observer(({ apiKeys, isLoading }) => {
    const formattedApiKeys = useMemo(() => {
      return apiKeys.map((apiData) => {
        const apiKeyString = apiData.apiKey || '';
        const stringLength = apiKeyString.length;
        const lastNChars = 4; // Show last 4 characters
        const maskedPart = 'X'.repeat(stringLength - lastNChars);
        const visiblePart = apiKeyString.slice(-lastNChars);

        return ({
          ...apiData,
          apiKey: `${maskedPart}${visiblePart}`,
          resellerId: apiData.metaData?.resellerId,
        });
      });
    }, [apiKeys]);

    const { t } = useTranslation('staticData');
    // const [selectedMetaData, setSelectedMetaData] = useState<Record<
    //   string,
    //   any
    // > | null>(null);

    // const [metaDataDialogVisible, setMetaDataDialogVisible] = useState(false);

    const [filters, setFilters] = useState({
      global: { value: '', matchMode: FilterMatchMode.CONTAINS },
      key: { value: '', matchMode: FilterMatchMode.CONTAINS },
      apiKey: { value: '', matchMode: FilterMatchMode.CONTAINS },
      uid: { value: '', matchMode: FilterMatchMode.CONTAINS },
      resellerId: { value: '', matchMode: FilterMatchMode.CONTAINS },
      // metaData: { value: '', matchMode: FilterMatchMode.CONTAINS },
    });

    const onRowClick = useCallback(({ data }: DataTableRowClickEvent) => {
      console.log(data);
    }, []);

    // const getMetaDataObjectBody = useCallback(
    //   (data: ApiStaticKey) => {
    //     const metaData = data?.metaData || {};
    //     return (
    //       <Button
    //         label={t('view_meta_data')}
    //         text
    //         onClick={() => {
    //           setSelectedMetaData(metaData);
    //           setMetaDataDialogVisible(true);
    //         }}
    //       />
    //     );
    //   },
    //   [t],
    // );

    if (isLoading) {
      return <Loading />;
    }

    return (
      <StyledGrid flex={1}>
        <DataTableContainer elevation={3}>
          <DataTable
            id="GrowerSystemsTable"
            showGridlines
            resizableColumns
            value={formattedApiKeys}
            selectionMode="single"
            scrollable
            scrollHeight="flex"
            dataKey="id"
            emptyMessage={t('empty_message')}
            stripedRows
            filters={filters}
            onRowClick={onRowClick}
            filterDisplay="row"
            globalFilterFields={['uid', 'apiKey', 'metaData']}
            paginator
            rows={10}
          >
            <Column field="uid" header={t('uid')} sortable filter />
            <Column field="apiKey" header={t('api_key')} sortable filter />
            <Column
              field="resellerId"
              header={t('reseller_id')}
              sortable
              filter
            />
            {/* <Column
              field="meta_data"
              header={t('meta_data')}
              sortable
              filter
              body={getMetaDataObjectBody}
              style={{ width: '10%', maxWidth: '10%' }}
            /> */}
          </DataTable>
        </DataTableContainer>
        {/* <MetaDataDialog
          visible={metaDataDialogVisible}
          onHide={() => setMetaDataDialogVisible(false)}
          header={t('meta_data')}
          style={{ width: '50vw' }}
        >
          <JsonViewContainer>
            {selectedMetaData && (
              <ReactJson
                src={selectedMetaData}
                name={false}
                collapsed={1}
                enableClipboard={false}
                displayDataTypes={false}
                style={{ fontSize: '14px' }}
              />
            )}
          </JsonViewContainer>
        </MetaDataDialog> */}
      </StyledGrid>
    );
  });

export default ApiKeysTable;
